import i18n from '@/translations'

const days = [
  { name: i18n.t('Monday'), short: 'M' },
  { name: i18n.t('Tuesday'), short: 'T' },
  { name: i18n.t('Wednesday'), short: 'W' },
  { name: i18n.t('Thursday'), short: 'T' },
  { name: i18n.t('Friday'), short: 'F' },
  { name: i18n.t('Saturday'), short: 'S' },
  { name: i18n.t('Sunday'), short: 'S' }
]

days.forEach(day => {
  day.upperCaseName = day.name.toUpperCase()
})

export default days



// WEBPACK FOOTER //
// ./src/utils/days.js